<template>
  <div class="organ-bd bd">
    <div class="aside">
      <div class="title">
        <i class="icon icon-zuzhi"></i>
        <span>{{ $t('base_department.bu_men') }}</span>
      </div>
      <div class="search">
        <el-input style="width: 100%" :placeholder="$t('base_department.bu_men_ming_cheng')" v-model="appKey" clearable></el-input>
      </div>
      <div class="tree">
        <custom-tree
          :data="organTree"
          node-key="bizId"
          default-expand-all
          :listener="appKey"
          :filterKeys="['bizName']"
          :props="{ label: 'bizName' }"
          v-model="organData"
          :action="treeAction"
          @add="addDepartment"
          @edit="editDepartment"
          @delete="deleteDepartment"
          @handleNode="handleNodeClick"
        >
          <template slot="label" slot-scope="scope">{{ scope.node.label }}({{ scope.data.bizUserCont }})</template>
        </custom-tree>
      </div>
    </div>
    <div class="section">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item v-if="funcView.department_user_bind || !!orgId">
            <el-button type="primary" @click="bindUsers" icon="el-icon-plus" :disabled="!organData.bizId || organData.bizType == 1">{{ $t('base_department.xin_zeng_yuan_gong') }}</el-button>
          </el-form-item>
          <el-form-item v-if="funcView.department_user_unbind || !!orgId">
            <el-button type="primary" icon="el-icon-minus" @click="unbindUsers" :disabled="!organData.bizId || !tableSelect.length || organData.bizType == 1">{{ $t('base_department.yi_chu_yuan_gong') }}</el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <!-- 搜索栏 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('base_department.ygxmdlzhlxdhyx')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table type="checkbox" tableCode="user_table" v-model="tableSelect" :data="organUserList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%">
          <el-table-column :label="$t('Common.com_handle')" fixed="right" v-if="funcView.department_user_unbind || !!orgId">
            <template slot-scope="scope">
              <el-button :disabled="!organData.bizId || organData.bizType == 1" @click="unbindUser(scope.row)" type="text" size="mini">{{ $t('Common.com_remove') }}</el-button>
            </template>
          </el-table-column>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <organ-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getOrganTree"></organ-dialog>
    <organ-users-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="successBindUsers"></organ-users-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import organDialog from '@/pages/base/components/organDialog.vue';
import customTree from '@/components/customTree.vue';
import organUsersDialog from './children/organ_users_dialog.vue';

export default {
  name: 'department',
  components: { organDialog, organUsersDialog, customTree },
  props: {
    orgId: [String, Number],
  },
  data() {
    return {
      tableSelect: [],
      appKey: '',
      userOrgId: '',
      organTree: [],
      organData: {},
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},

      organUserList: [],
      totalRows: 0,
      childrenCount: 0,
      totalCount: 0,
      isLoading: false,

      formSearch: {
        search: '',
        bizId: '',
        bizType: '',
        pageSize: 50,
        pageNum: 1,
        isAssociated: 1,
      },
    };
  },
  computed: {
    treeAction() {
      return this.organData.bizType === 2
        ? {
          add: this.funcView.department_add || !!this.orgId,
          edit: this.funcView.department_edit || !!this.orgId,
          delete: this.funcView.department_delete || !!this.orgId,
        }
        : {
          add: this.funcView.department_add || !!this.orgId,
        };
    },
  },
  mounted() {
    this.reserFormSearch = JSON.stringify(this.formSearch);
    this.getOrganTree();
    this.getFuncView('/company/department');
  },
  methods: {
    // 选中部门
    handleNodeClick: function () {
      this.formSearch = JSON.parse(this.reserFormSearch);
      this.getOrganUserPage();
      this.getDepartmentCount();
    },
    // 获取部门树
    getOrganTree: function () {
      this.$getJSON(apis.DepartmentTree, { isCountUser: 1, orgId: this.orgId }).then((res) => {
        this.organTree = [res.data];
        const obj = res.data || {};
        this.userOrgId = obj.orgId;
      });
    },
    // 新增部门
    addDepartment: function (data) {
      const title = this.$t('base_department.xin_zeng_bu_men');
      this.dialogModel = { ...data, orgId: this.orgId };
      this.dialogModel.type = 'add';
      this.dialogModel.title = title;
      this.dialogVisible = true;
    },
    // 编辑部门
    editDepartment: function (data) {
      const title = this.$t('base_department.bian_ji_bu_men');
      this.dialogModel = { ...data, orgId: this.orgId };
      this.dialogModel.type = 'edit';
      this.dialogModel.title = title;
      this.dialogVisible = true;
    },
    // 删除部门
    deleteDepartment: function (data) {
      const title = this.$t('base_department.nqdyscxzdbmm');
      this.$showConfirm(title)
        .then(() => {
          this.$postJSON(`${apis.DepartmentDelete}/${data.departmentId}`).then(() => {
            this.getOrganTree();
          });
        })
        .catch(() => {});
    },
    // 关联用户弹窗
    bindUsers: function () {
      const title = this.$t('base_department.tjygdbm');
      this.dialogModel1.title = title;
      this.dialogModel1.data = { ...this.organData, orgId: this.orgId || this.userOrgId };
      this.dialogVisible1 = true;
    },
    // 关联用户成功
    successBindUsers: function () {
      this.getOrganTree();
      this.getOrganUserPage();
    },
    // 取消关联部门
    unbindUser: function (data) {
      const title = this.$t('base_department.nqdyjxzdygyczgbmm');
      this.$showConfirm(title)
        .then(() => {
          this.$postJSON(apis.DepartmentUserUnbind, {
            departmentId: this.organData.bizId,
            userIds: [data.userId],
          }).then(() => {
            this.getOrganTree();
            this.getOrganUserPage();
          });
        })
        .catch(() => {});
    },
    // 取消关联部门(批量)
    unbindUsers: function () {
      const title = this.$t('base_department.nqdyjxzdygyczgbmm');
      this.$showConfirm(title)
        .then(() => {
          const params = this.tableSelect.map(t => t.userId);
          this.$postJSON(apis.DepartmentUserUnbind, {
            departmentId: this.organData.bizId,
            userIds: params,
          }).then(() => {
            this.getOrganTree();
            this.getOrganUserPage();
          });
        })
        .catch(() => {});
    },
    // 获取部门用户列表
    getOrganUserPage: function () {
      this.formSearch.bizId = this.organData.bizId;
      this.formSearch.bizType = this.organData.bizType;
      this.isLoading = true;
      this.$getJSON(apis.DepartmentUserPage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.organUserList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 获取部门统计数
    getDepartmentCount: function () {
      this.$getJSON(apis.DepartmentCount, {
        bizId: this.organData.bizId,
        bizType: this.organData.bizType,
      }).then((res) => {
        this.childrenCount = res.data.childrenCount;
        this.totalCount = res.data.totalCount;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getOrganUserPage();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
@import '@/style/mixin.scss';

.organ-bd {
  height: 100%;
  padding: 16px;
  position: relative;
  & > .aside {
    position: absolute;
    box-shadow: 0.5px 0px 3px 0px rgba(51, 51, 51, 0.12);
    top: 0;
    left: 0;
    bottom: 0;
    width: 240px;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    background-color: #ffffff;
    overflow: auto;
    .title {
      padding: 0 10px;
      line-height: 70px;
      color: #394668;
      font-weight: bold;
      font-size: 15px;
      .icon {
        float: left;
        font-size: 14px;
        margin-right: 8px;
        font-weight: normal;
        @include color_main();
      }
    }
    .search {
      margin: 0 10px 16px;
    }
    .list {
      .el-tree-node__content > .el-tree-node__expand-icon {
        display: none;
      }
      .el-tree-node__content .tree-item {
        padding-left: 10px;
      }
    }
    .list,
    .tree {
      flex: 1;
      margin: 0 10px;
      overflow-y: auto;
      .el-tree-node__content {
        line-height: 32px;
        height: 32px;
        &:hover {
          background-color: #f8f9fb;
        }
      }
      .el-tree-node__content > .el-tree-node__expand-icon {
        color: #495057;
        &.is-leaf {
          color: transparent;
        }
      }
      .is-current > .el-tree-node__content {
        background-color: #eef2f8 !important;
        .tree-item {
          @include color_main();
          .icon {
            @include color_main();
            font-size: 12px;
          }
          .disable {
            color: rgba(108, 117, 125, 0.5);
          }
        }
      }
      .tree-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        padding-right: 10px;
        overflow: hidden;
        color: #6c757d;
        .disable {
          color: rgba(108, 117, 125, 0.5);
        }
      }
    }
  }
  & > .section {
    height: 100%;
    margin-left: 240px;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    padding: 0 16px;
    &.padding0 {
      padding: 0;
    }
    .section-info {
      padding-top: 16px;
      table {
        width: 100%;
      }
      table tr {
        height: 44px;
        line-height: 44px;
        text-align: left;
        th {
          padding: 0 10px;
          font-size: 12px;
          color: #636e78;
          background-color: #f2f3fb;
        }
        td {
          padding: 0 10px;
          color: #6c757d;
          font-size: 12px;
          border-bottom: 1px solid #eef2f8;
        }
      }
    }
    .table-bd {
      flex: 1;
      height: 0;
    }
  }
  .tip {
    background: rgba(53, 184, 224, 0.15);
    margin-top: 16px;
    padding-left: 10px;
    .icon {
      color: #0d9ae0;
      font-size: 12px;
      margin-right: 10px;
    }
    span {
      line-height: 32px;
      color: #6c757d;
      font-size: 12px;
    }
  }
}
</style>
